import React from "react";
import { useState } from "react";

const blogCardStyle = `
  .blog-card-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Inter', sans-serif;
    margin-bottom:15px;
  }

  .blog-card {
    background: linear-gradient(130.69deg, #1C2045 17.63%, #080B2C 55.51%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    padding: 20px;
    max-width: 520px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .blog-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 20% 50%, rgba(99, 120, 255, 0.06) 0%, transparent 60%);
    pointer-events: none;
  }

  .blog-card-content {
    flex: 1;
    min-width: 0;
  }

  .blog-date {
    font-family: 'Inter', sans-serif;
    font-size: 11.5px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.4);
    letter-spacing: 0.04em;
    margin-bottom: 10px;
  }

  .blog-title {
    font-family: 'Sora', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.3;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .blog-excerpt {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.45);
    line-height: 1.6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .blog-card-thumbnail {
    flex-shrink: 0;
    width: 130px;
    height: 100px;
    border-radius: 12px;
    overflow: hidden;
    background: #0d1117;
    border: 1px solid rgba(255, 255, 255, 0.08);
    position: relative;
  }

  .thumbnail-mock {
    width: 100%;
    height: 100%;
    background: linear-gradient(160deg, #0f1720 0%, #1a2540 100%);
    display: flex;
    flex-direction: column;
    padding: 8px;
    gap: 5px;
    position: relative;
  }

  .thumb-topbar {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .thumb-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .thumb-lines {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 4px;
  }

  .thumb-line {
    height: 4px;
    border-radius: 2px;
    background: rgba(255,255,255,0.1);
  }

  .thumb-line-short {
    width: 55%;
  }

  .thumb-accent {
    position: absolute;
    bottom: 6px;
    right: 6px;
    width: 28px;
    height: 16px;
    border-radius: 4px;
    background: linear-gradient(135deg, #3b5bdb, #6c3de8);
    opacity: 0.8;
  }
`;

export default function BlogCard({ blog, onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <style>{blogCardStyle}</style>

      <div className="blog-card-wrapper">
        <div
          className="blog-card"
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {/* Text Content */}
          <div className="blog-card-content">
            <div className="blog-date">
              {blog?.published_at}
            </div>

            <div className="blog-title">
              {blog?.title}
            </div>

            <div className="blog-excerpt text-truncate">
              {blog?.short_description}
            </div>
          </div>

          {/* Thumbnail */}
          <div className="blog-card-thumbnail">
            {blog?.featured_image ? (
              <img
                src={blog.featured_image}
                alt={blog.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "12px",
                }}
              />
            ) : (
              <div className="thumbnail-mock">
                <div className="thumb-topbar">
                  <div
                    className="thumb-dot"
                    style={{ background: "#ff5f57" }}
                  />
                  <div
                    className="thumb-dot"
                    style={{ background: "#febc2e" }}
                  />
                  <div
                    className="thumb-dot"
                    style={{ background: "#28c840" }}
                  />
                </div>

                <div className="thumb-lines">
                  <div
                    className="thumb-line"
                    style={{ width: "80%" }}
                  />
                  <div
                    className="thumb-line"
                    style={{ width: "65%" }}
                  />
                  <div className="thumb-line thumb-line-short" />
                  <div
                    className="thumb-line"
                    style={{ width: "70%" }}
                  />
                  <div
                    className="thumb-line"
                    style={{ width: "40%" }}
                  />
                </div>

                <div className="thumb-accent" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}